export default {
  data() {
    return {
      dataForm: {},
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false,
      agentLoading: false,
      agentOptions: []
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.loading = true
      return this.$http.get(this.pageUrl, {
        params: { page: this.page, limit: this.limit, ...this.dataForm }
      }).then(({ data: res }) => {
        if (res.code !== 0) return this.$message.error(res.msg)
        const pageData = res.data.page || res.data
        this.dataList = pageData.list || []
        this.total = pageData.total || 0
        if (res.data.stats) this.stats = res.data.stats
      }).finally(() => { this.loading = false })
    },
    search() {
      this.page = 1
      this.getDataList()
    },
    searchAgents(username) {
      const keyword = username.trim()
      if (!keyword) {
        this.agentOptions = []
        return
      }

      this.agentLoading = true
      this.$http.get('/agent/page', {
        params: {
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.agentOptions = []
          return this.$message.error(data.msg)
        }
        const pageData = data.data.page || data.data
        this.agentOptions = pageData.list || []
      }).finally(() => {
        this.agentLoading = false
      })
    },
    agentLabel(agent) {
      const nickname = agent.nickname ? ` - ${agent.nickname}` : ''
      return `${agent.username}${nickname}（ID: ${agent.id}）`
    },
    sizeChange(value) {
      this.page = 1
      this.limit = value
      this.getDataList()
    },
    currentChange(value) {
      this.page = value
      this.getDataList()
    },
    statusText(status) {
      return ({ 0: '禁用', 1: '启用', 2: '已禁用' })[status] || '-'
    },
    statusType(status) {
      return status === 1 ? 'success' : 'danger'
    },
    payTypeText(type) {
      return ({ 1: '支付宝', 2: '微信', 3: '银行卡', 4: 'USDT' })[type] || type || '-'
    }
  }
}
